<p-confirmDialog></p-confirmDialog>
<div class="flex flex-column gap-3">
  <p-card header="Locations">
    <ng-template pTemplate="header">
      <div class="flex align-items-center justify-content-end gap-2">
        <p-button
          label="Add location"
          icon="pi pi-plus"
          (onClick)="add()"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-download"
          (onClick)="exportLocations()"
          [disabled]="!locations || locations.length === 0"
        ></p-button>
      </div>
    </ng-template>
    <p-table
      [value]="locations"
      [loading]="loading"
      dataKey="companyName"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      [globalFilterFields]="['companyName']">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="companyName">
            Company name
            <p-sortIcon field="companyName"/>
          </th>
          <th pSortableColumn="firstName">
            First name
            <p-sortIcon field="firstName"/>
          </th>
          <th pSortableColumn="lastName">
            Last name
            <p-sortIcon field="lastName"/>
          </th>
          <th pSortableColumn="addressLine1">
            Address
            <p-sortIcon field="addressLine1"/>
          </th>
          <th pSortableColumn="city">
            City
            <p-sortIcon field="city"/>
          </th>
          <th pSortableColumn="state">
            State
            <p-sortIcon field="state"/>
          </th>
          <th pSortableColumn="zipCode">
            Zip
            <p-sortIcon field="zipCode"/>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record>
        <tr>
          <td>{{ record.companyName }}</td>
          <td>{{ record.firstName }}</td>
          <td>{{ record.lastName }}</td>
          <td>{{ record.addressLine1 }} {{ record.addressLine2 }}</td>
          <td>{{ record.city }}</td>
          <td>{{ record.state }}</td>
          <td>{{ record.zipCode }}</td>
          <td>
            <div class="flex justify-content-end gap-1">
              <p-button
                [icon]="'pi pi-pencil'"
                [rounded]="true"
                [raised]="true"
                severity="info"
                size="small"
                title="Edit"
                (onClick)="edit(record)"
              />
              <p-button
                [icon]="'pi pi-trash'"
                [rounded]="true"
                [raised]="true"
                severity="danger"
                size="small"
                title="Delete"
                (onClick)="delete(record)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="text-center py-7">No results found</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<app-client-onboarding-wizard-buttons
  [nextDisabled]="false"
  (buttonClicked)="onWizardButtonClick($event)"></app-client-onboarding-wizard-buttons>
